import { Component } from '@angular/core';

@Component({
  selector: 'fgb-exclusive-offers',
  templateUrl: './exclusive-offers.component.html',
  styleUrl: './exclusive-offers.component.scss'
})
export class ExclusiveOffersComponent {

}
